import { useEffect } from 'react';

import { ProgressStatus } from '../components/Modals/ProgressModal/progress-types.ts';

const tickIncreasesRange = [
	{ min: 30, max: 45, multiplier: 2 },
	{ min: 63, max: 80, multiplier: 10 },
	{ min: 86, max: 100, multiplier: 100 },
];
const INITIAL_TICK = 50;
const MAX_PROGRESS = 99;

export const useHandleProgressBar = (
	status: string | null,
	progress: number,
	setProgress: (value: number) => void,
): void => {
	useEffect(() => {
		let timer;

		const clearTimer = () => {
			timer && clearTimeout(timer);
		};

		if (status === ProgressStatus.IN_PROGRESS && progress < MAX_PROGRESS) {
			const tickCoefficient = tickIncreasesRange.find(
				({ min, max }) => progress >= min && progress < max,
			);
			const tick = INITIAL_TICK * ((tickCoefficient && tickCoefficient.multiplier) || 1);

			timer = setTimeout(() => {
				setProgress(progress + 1);
			}, tick);

			return clearTimer;
		}
		if (status === ProgressStatus.SUCCESS) {
			setProgress(100);
		}
	}, [status, progress, setProgress]);
};
